import React from "react";

export const PageSettings = React.createContext();

export const zhName = "除除";
export const enName = "mazey";
export const pageTitle = zhName;
